<template>
  <div  id="activity-login">
    <img style="position: absolute;bottom: 0;width: 260px;height: 210px" src="../../assets/Login/show_app_pic.png" alt="">
    <div v-show="!showRegisterSuccess">
      <div style="position: relative;width: 350px;margin: 80px auto 0 auto">

        <!-- 圆角卡片底图蒙层  宽为350px时高度为480px-->
        <div style="position: absolute;width: 100%;">
          <div style="width: 100%;height: 100px;overflow: hidden">
            <img style="width: 100%;" src="../../assets/Login/round_corner_card.png" alt="">
          </div>

          <div :style="{'height': loginMethod === 'phone' ? '280px' : '220px'}" style="width: 100%;overflow: hidden">
            <img style="width: 100%;transform: translateY(-100px);" src="../../assets/Login/round_corner_card.png" alt="">
          </div>

          <div style="width: 100%;height: 100px;overflow: hidden;">
            <img style="width: 100%;transform: translateY(-380px);" src="../../assets/Login/round_corner_card.png" alt="">
          </div>
        </div>

        <div class="gradient-text" style="font-size: 24px;position: absolute;top: 20px;left: 20px;">共生地球</div>
        <img style="width: 100px;height: 100px;position: absolute;top: 12px;right: 20px" src="/app-assets/image/user_system/iconLogo.png" alt="">

        <!--登录信息表单-->
        <div :style="{'height': loginMethod === 'phone' ? '420px' : '360px'}" style="position: absolute;top: 60px;width: 100%;">

          <!-- 圆角卡片曲线蒙层  宽为350px时高度为420px-->
          <div style="position: absolute;width: 100%;">
            <div style="width: 100%;height: 100px;overflow: hidden">
              <img style="width: 100%;" src="../../assets/Login/round_corner_card_curve.png" alt="">
            </div>

            <div :style="{'height': loginMethod === 'phone' ? '220px' : '160px'}" style="width: 100%;overflow: hidden">
              <img style="width: 100%;transform: translateY(-100px);" src="../../assets/Login/round_corner_card_curve.png" alt="">
            </div>

            <div style="width: 100%;height: 100px;overflow: hidden;">
              <img style="width: 100%;transform: translateY(-320px);" src="../../assets/Login/round_corner_card_curve.png" alt="">
            </div>
          </div>

          <div style="position: absolute;top: 0;width: 100%;height: 100%">
            <div style="margin-top: 15px;margin-left: 10px">
              <div class="gradient-text" style="font-size: 12px;left: 10px;top: 15px;">
                <span class="iconfontFamily">&#xe621;</span> 解锁2025年最新影像</div>
              <div class="gradient-text" style="font-size: 12px;left: 10px;top: 15px;margin-top: 8px">
                <span class="iconfontFamily">&#xe621;</span> 海量高清历史影像</div>
              <div class="gradient-text" style="font-size: 12px;left: 10px;top: 15px;margin-top: 8px">
                <span class="iconfontFamily">&#xe621;</span> 操控卫星帮你拍想看的地方</div>
            </div>

            <!--短信登录-->
            <div v-show="loginMethod === 'phone'" style="width: 100%;margin-top: 12px;padding-left: 20px;padding-right: 20px;box-sizing: border-box">

              <!--手机号 -->
              <input v-model="phoneNum" placeholder="手机号" class="standard-input custom-input-style" style="margin-top: 13px">

              <!--图形验证-->
              <div style="position: relative;height: 48px;margin-top: 13px;">
                <input v-model="picCaptcha" placeholder="图形验证码" class="standard-input custom-input-style">
                <div style="width:98px;height: 34px;position:absolute;top: 7px;right: 10px">
                  <img v-show="phoneNum.length === 11 && picCaptchaPic.length > 0" @click="getPicCaptcha" :src="picCaptchaPic" style="width:100%;height: 100%" alt="">
                </div>
              </div>

              <!--验证码-->
              <div style="margin-top: 13px;position: relative">
                <input v-model="msgCaptcha" placeholder="短信验证码" class="standard-input custom-input-style">
                <div @click="existPhone" :style="{'color':sendingAvailable  ? 'white':'#CCCCCCFF','background':sendingAvailable ? '#2A82E4FF' : '#2A82E47F'}" id="send-msg-btn">
                  {{sendMsgBtnContent}}
                </div>
              </div>
            </div>

            <!--密码登录-->
            <div v-show="loginMethod === 'password'" style="width: 100%;margin-top: 12px;padding-left: 20px;padding-right: 20px;box-sizing: border-box">

              <!--手机号 -->
              <input v-model="account" placeholder="手机号" class="standard-input custom-input-style" style="margin-top: 13px">

              <!--密码-->
              <input v-model="password" placeholder="密码" type="password" class="standard-input custom-input-style" style="margin-top: 13px">
            </div>

            <!--隐私政策-->
            <div style="display: flex;margin-top: 15px;margin-left: 22px">
              <div v-show="!privacyChecked" @click="privacyChecked = true" style="width: 12px;height: 12px;border-radius: 50%;border: solid 1px #CCCCCCFF;"></div>
              <span v-show="privacyChecked" @click="privacyChecked = false" style="font-size: 14px;line-height: 15px;color: #2A82E4FF" class="iconfontFamily">&#xe621;</span>
              <div class="hintText" style="font-size: 12px;color: #CCCCCCFF;line-height: 15px;margin-left: 6px">我已阅读
                <span @click="goUserAgreement" style="color: #3264EDFF;">用户协议</span>和
                <span @click="goPrivacy" style="color: #3264EDFF;">隐私政策</span>
              </div>
            </div>

            <!--登录按键-->
            <div id="login-button" @click="clickLoginBtn" :style="{'color':loginAvailable  ? 'white':'#CCCCCCFF','background':loginAvailable ? '#2A82E4FF' : '#2A82E47F'}">{{loginMethod === 'phone' ?  inviteId !== '' ? '注册' : '注册/登录' : '登录'}}</div>

            <!--切换登录方式-->
            <div v-if="!inviteId" @click="switchLoginMethod" style="font-size: 14px;color: #3264EDFF;width: fit-content;margin: 20px auto 0 auto">{{loginMethod === 'phone' ? '密码登录' : '手机验证码注册/登录'}}  </div>
          </div>

        </div>
      </div>
      <div :style="{'top': loginMethod === 'phone' ? '565px' : '505px'}" style="font-size: 12px;color: #979797;position: absolute;width: 350px;left: calc(50% + 4px);transform: translateX(-50%)">*未注册手机验证后自动登录</div>
    </div>

    <div v-show="showRegisterSuccess" style="position: absolute;top: 30%;left: 50%;transform: translateX(-50%);width: 100%">
      <img style="width: 100px;height: 100px;margin: 0 auto;display: block" src="../../assets/Login/register_success.png" alt="">
      <div style="color: white;font-size: 20px;text-align: center">注册成功</div>
      <div style="color: rgba(255, 255, 255, 0.5);font-size: 14px;text-align: center;margin-top: 10px">下载共生地球开启你的卫星帮拍</div>
    </div>

    <TopShareBar></TopShareBar>

    <!--Toast-->
    <div v-show="toastShowFlag" style="width: 100%;height: 100%;pointer-events: auto;position: fixed; top: 0; left: 0;">
      <div id="toast-style">
        <div class="toast-text-style"> <span class="iconfontFamily">&#xe79e;</span> {{toastMsg}}</div>
      </div>
    </div>

  </div>
</template>

<script>
import TopShareBar from "@/components/TopShareBar";
export default {
  name: "ActivityLogin",
  components: { TopShareBar},
  mounted() {
    if(this.$route.query.inviteId){
      this.inviteId = this.$route.query.inviteId
    }
  },
  data(){
    return{
      inviteId:'',
      toastMsg:"",
      toastShowFlag:false,
      loginMethod:'phone',
      prefix:"86",
      phoneNum:'',
      msgCaptcha:'',
      picCaptcha:'',
      privacyChecked:false,
      picCaptchaPic:'',
      sendMsgBtnContent:'发送验证码',
      account:'',
      password:'',
      countDownNum:60,
      showRegisterSuccess:false
    }
  },
  watch:{
    phoneNum(){
      if(this.phoneNum.length === 11){
        this.getPicCaptcha()
      }
    }
  },
  computed:{
    sendingAvailable(){
      return this.phoneNum.length === 11 && this.picCaptcha.length === 4 && this.sendMsgBtnContent === "发送验证码"
    },
    loginAvailable(){
      if(this.loginMethod === 'phone'){
        return this.phoneNum.length === 11 && this.picCaptcha.length === 4 && this.msgCaptcha.length > 0 && this.privacyChecked
      }else {
        return this.account.length > 0 && this.password.length > 0 && this.privacyChecked
      }
    },
  },
  methods:{
    showToast(toast){
      this.toastMsg = toast
      this.toastShowFlag = true
      setTimeout(() => {
        this.toastShowFlag = false
      },3000)
    },
    goPrivacy(){
      this.$router.push(
          {
            path: '/PrivacyAndAgreement/privacy',
          }
      )
    },
    goUserAgreement(){
      this.$router.push(
          {
            path: '/PrivacyAndAgreement/agreement',
          }
      )
    },
    switchLoginMethod(){
      if(this.loginMethod === 'phone'){
        this.loginMethod = 'password'
      } else{
        this.loginMethod = 'phone'
      }
    },
    getPicCaptcha(){
      if(this.phoneNum.length !== 11) return
      let formData = new FormData()
      formData.append('phone',this.phoneNum)
      formData.append('prefix',"+" + this.prefix)
      this.$http.post('/userApi/getPhonePicCaptcha', formData).then(resultData => {
        resultData = resultData.data;
        if(resultData.code === 200){
          this.picCaptchaPic = resultData.data.picture;
        }
      })
    },
    async existPhone() {
      if(!this.sendingAvailable) {
        if(this.phoneNum.length !== 11){
          this.showToast('请输入正确手机号')
        } else if(this.picCaptcha.length !== 4){
          this.showToast('请输入正确图形验证码')
        }
        return
      }

      if(!this.inviteId){
        this.sendPhoneVerificationCode()
        return
      }

      let response = await this.$http.get('/userApi/existPhone', {
        params: {
          "phone": this.phoneNum,
        }
      });
      if (response.data.code === 200) {
        if(response.data.data){
          this.showToast('当前手机号已注册')
        }else{
          this.sendPhoneVerificationCode()
        }
      }
    },
    sendPhoneVerificationCode(){
      let formData = new FormData()
      formData.append('phone',this.phoneNum)
      formData.append('prefix',"+" + this.prefix)
      formData.append('picCaptcha',this.picCaptcha)
      formData.append( 'purpose','loginOrRegister')
      this.$http.post('/userApi/sendCodeForAction',formData).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.code === 4015){
          this.showToast('请输入正确图形验证码')
        }
        else if(resultData.code === 4014){
          this.showToast('操作频繁，请1分钟后再试')
        }
        else{
          this.clock = window.setInterval(() => {
            this.countDownNum--;
            this.sendMsgBtnContent = "重新发送（"+this.countDownNum+')'
            if (this.countDownNum < 1) {
              window.clearInterval(this.clock);
              this.countDownNum = 60;
              this.sendMsgBtnContent = "发送验证码"
              this.getPicCaptcha()
            }
          }, 1000);
        }
      })
    },
    clickLoginBtn(){
      if(this.loginMethod === 'phone'){
        this.checkVerifyCode()
      }else {
        this.loginByPassword()
      }
    },
    async checkVerifyCode() {
      if(!this.loginAvailable){
        if(this.phoneNum.length !== 11){
          this.showToast('请输入正确的手机号')
        } else if(this.msgCaptcha.length !== 6){
          this.showToast('请输入正确短信验证码')
        } else if(!this.privacyChecked){
          this.showToast('请阅读用户协议和隐私政策')
        }
        return
      }
      let response = await this.$http.get('/userApi/checkCodeEarth',{params:{
          "captcha":this.msgCaptcha,
          "phone":this.phoneNum,
          "prefix": "+" + this.prefix,
          "device": "phone",
          "purpose": "loginOrRegister",
          "site": "earth",
          "inviteId":this.inviteId,
        }});
      if (response.data.code === 200) {
        await this.saveLoginInfo(response.data)
      }else if(response.data.code === 4007){
        this.showToast('验证码过期')
      }else{
        this.showToast('请输入正确短信验证码')
      }
    },
    async loginByPassword() {
      if(!this.loginAvailable){
        if(this.account.length === 0){
          this.showToast('请输入正确的账号')
        } else if(this.password.length === 0){
          this.showToast('请输入正确的密码')
        } else if(!this.privacyChecked){
          this.showToast('请阅读用户协议和隐私政策')
        }
        return
      }
      let response = await this.$http.get('/userApi/loginEarth', {
        params: {
          "username": this.account,
          "password": this.password,
          "device": "phone",
          "site": "earth"
        }
      });
      if (response.data.code === 200) {
        await this.saveLoginInfo(response.data)
      }else if(response.data.code === 4013){
        this.showToast('操作频繁，请1分钟后再试')
      }else if(response.data.code === 4005){
        this.showToast('用户未注册或设置密码,请使用短信验证码登录')
      }else{
        this.showToast('账号或密码不正确')
      }
    },
    async saveLoginInfo(response) {
      this.$store.commit('setToken', response.token)
      this.$store.commit('setPhone', response.data.phone)
      this.$store.commit('setUserId', response.data.userId)
      let formData = new FormData()
      formData.append('userId', this.$store.state.userId)
      let res = await this.$http.post('/earthApi/data/getPersonalData', formData, {headers: {'Authorization': this.$store.state.token}})
      if (res.body.status === 200) {
        this.$store.commit('setNickName', res.body.data.nickName)
        this.$store.commit('setAvatar', res.body.data.picture)
        this.$store.commit('setMember', res.body.data.member.toString())
        if(this.inviteId){
          this.showRegisterSuccess = true
        }else{
          this.showToast('操作成功！')
          setTimeout(()=>{
            this.goBack()
          },3000)
        }
      }
    },
    goBack(){
      this.$router.go(-1)
    },
  },

}
</script>

<style scoped>
#activity-login{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background:#0F1419;
}

#toast-style{
  position: fixed;
  left: 50%;top: 50%;
  transform: translate(-50%,-50%);
  width: 190px;height: fit-content;
  background: #2C2B2BB2;
  border-radius: 8px;
  padding: 20px 5px 20px 5px;
  min-height: 85px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center
}

.toast-text-style{
  font-size: 14px;color: white;text-align: center;height: fit-content;
}

input::-webkit-input-placeholder{
  color: #CCCCCCFF;
  font-size: 16px;
}

/* 文字整体渐变 */
.gradient-text {
  background: linear-gradient(135deg, #4A9AFF 0%, #86B4FF 20%, #278DFF 50%, #3DC4FF 80%, #5CDEFF 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent; /* 备用 */
  font-weight: bold;
  font-family:HarmonyOSSansSCRegular;
}

.standard-input{
  -webkit-appearance: none; /* 针对Chrome和Safari */
  -moz-appearance: none;    /* 针对Firefox */
  appearance: none;         /* 针对标准浏览器 */
  border: none;
  outline: none;
}

.custom-input-style{
  height: 48px;
  box-sizing: border-box;
  width: 100%;
  background: #FFFFFF23;
  border-radius: 10px;
  padding-left: 20px;
  font-size: 16px;
  color: white;
}

#send-msg-btn{
  width:114px;height: 36px;
  position:absolute;
  top: 6px;right: 5px;
  font-size: 16px;
  line-height: 36px;text-align: center;
  border-radius: 6px
}

#login-button{
  width: calc(100% - 40px);height: 48px;
  background: #3264EDFF;
  border-radius: 10px;
  margin: 15px auto 0 auto;
  color: white;font-size: 16px;
  line-height: 48px;text-align: center
}

</style>